<template>
  <div>
    <div class="row">
      <div class="col-12">
        <page-header
          :page="page"
          @onReturn="() => $router.back()"
          :has-return="true"
        />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <filter-manager
          :display-advanced="false"
          class="search-bar"
          items-container-class="flex-wrap"
          search-icon="fa fa-sync"
          search-text="Procesar"
          search-container-class="btn-process"
          v-model="model.search.filters"
          :filters="filterManagerConfig"
          @search="onHandlerSearch"
          ref="filterRef"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader'
import FilterManager from 'FilterManager'
import AcademicYearServices from '@/services/api/academicyear.api'
import providerApi from '@/services/api/provider.api'
import ReportServices from '@/modules/report/api'
import DocumentServices from '@//modules/report/document'
import ROLE from '@/utils/role'
export default {
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => ({
    page: {
      icon: 'fas fa-clipboard-list-check',
      title: 'Citas Coordinadas No Completadas',
      routes: ['Informes', 'Citas Coordinadas No Completadas'],
    },
    model: {
      search: {
        collections: {
          academicYears: [],
          providers: [],
          dateTo: [],
          dateFrom: [],
        },
        filters: {
          academicYear: null,
          provider: null,
          dateTo: null,
          dateFrom: null,
        },
      },
    },
  }),
  computed: {
    filterManagerConfig() {
      return [
        {
          name: 'academicYear',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'description',
          label: 'Año Académico',
          placeholder: 'Seleccionar',
          error: 'Favor seleccionar un año académico.',
          validations: 'required',
          class: 'col-md-2',
          clearable: false,
          options: this.model.search.collections.academicYears,
          value: this.model.search.filters.academicYear,
          onChanged: this.onChangeAcademicYear,
        },
        {
          name: 'provider',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Proveedor',
          placeholder: 'Seleccionar',
          error: 'Favor seleccionar Proveedor',
          validations: 'required',
          clearable: false,
          class: 'col-md-6',
          options: this.model.search.collections.providers,
          value: this.model.search.filters.provider,
          disabled:
            this.model.search.collections.providers.length <= 0 ||
            this.model.search.collections.providers.length == 1,
        },
        {
          name: 'dateFrom',
          component: 'custom-date-picker',
          label: 'Fecha Desde',
          placeholder: 'Seleccionar Fecha Desde',
          error: 'Fecha Desde es requerida.',
          validations: 'required',
          class: 'col-md-2',
          classContainer: 'date-width-container',
          maxDate: new Date(),
          value: this.model.search.filters.dateTo,
        },
        {
          name: 'dateTo',
          component: 'custom-date-picker',
          label: 'Fecha Hasta',
          placeholder: 'Seleccionar Fecha Hasta',
          error: 'Fecha Hasta es requerida.',
          validations: 'required',
          class: 'col-md-2',
          classContainer: 'date-width-container',
          maxDate: new Date(),
          value: this.model.search.filters.dateTo,
        },
      ]
    },
  },
  async mounted() {
     this.applyInitProviderRole()
      await this.setFilters()
  },
  methods: {
    hasValue(param) {
      return param !== null && param !== undefined
    },
    async setFilters() {
      await AcademicYearServices.getCurrentYearAcademicYears().then(
        (res) => {
          this.model.search.collections.academicYears = res.data
          let years = (this.model.search.filters.academicYear = res.data.filter(
          (x) => x.selected
        ))
         this.model.search.filters.academicYear =
          years.length > 0 ? years[0] : null
        
        })
        if (this.model.search.filters.academicYear != null) {
        this.onChangeAcademicYear()
      }
    },
    async onChangeAcademicYear() {
      this.model.search.filters.provider = null
      await this.getProvider()
    },
    async getProvider() {
      if (this.applyInitProviderRole()) return;
      await providerApi
        .getAllProvidertCompaniesByYear({
          academicYearId: this.model.search.filters.academicYear?.id,
        })
        .then((res) => {
          const userCompanyIds = this.userCompanies.map(x => x.id);
          var availableCompanies = this.userRole == ROLE.Provider ?
          res.data.filter(x => userCompanyIds.includes(x.id))
          : res.data; 
          this.model.search.collections.providers = availableCompanies;
          if (res.data.length == 1) {
            this.model.search.filters.provider = res.data[0]
          }
        })
    },
    async onHandlerSearch() {
      this.process()
    },
    applyInitProviderRole() {
      const isProviderRole = this.userRole == ROLE.Provider;
      const hasOnlyOneCompany = this.userCompanies.length == 1;
      if (isProviderRole && hasOnlyOneCompany) {
        this.model.search.filters.provider = this.userCompanies[0];
      }
      return isProviderRole && hasOnlyOneCompany;
    },
    async process() {
      const isValid = await this.$refs.filterRef.$refs.formValidator.validate()

      if (!isValid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información solicitada.',
          'error'
        )
        return
      }

      if (
        this.model.search.filters.dateFrom > this.model.search.filters.dateTo
      ) {
        this.ShowToast(
          'Atención',
          'La Fecha Hasta no puede ser menor a la Fecha Desde.',
          'error'
        )
        return
      }

      await ReportServices.getReport(
        'reportcoordinatedappointmentsnotcompleted',
        {
          academicYearId: this.model.search.filters.academicYear?.id,
          providerId: this.model.search.filters.provider?.id,
          fechaDesde: this.model.search.filters.dateFrom,
          fechaHasta: this.model.search.filters.dateTo,
        }
      ).then((res) => DocumentServices.Download(res.data))
    },
  },
}
</script>
